import { render, staticRenderFns } from "./customerset.vue?vue&type=template&id=6aadc426&scoped=true"
import script from "./customerset.vue?vue&type=script&lang=js"
export * from "./customerset.vue?vue&type=script&lang=js"
import style0 from "./customerset.vue?vue&type=style&index=0&id=6aadc426&prod&lang=less&scoped=true"
import style1 from "./customerset.vue?vue&type=style&index=1&id=6aadc426&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadc426",
  null
  
)

export default component.exports